class ShopifyHttpGateway {
  post = async ({ query }) => {
    try {
      const response = await fetch(
        `https://${process.env.GATSBY_MYSHOPIFY_URL}/api/2024-01/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token':
              process.env.GATSBY_MYSHOPIFY_TOKEN,
          },
          body: query,
        }
      );

      if (response.status === 401) {
        // toast an API error unauthorized
        return {};
      }

      const responseDto = await response.json();
      return responseDto;
    } catch (error) {
      // toast an API error unknown
    }
  };
}

const shopifyHttpGateway = new ShopifyHttpGateway();
export default shopifyHttpGateway;
